export default __webpack_public_path__ + "static/media/hello2.0b20beaa.png";